import type { TFunction } from 'react-i18next';
import type { KiCodeTarget } from './profiles';

export const KICODE_FILES_WARNING = 'KiCode version files could not be loaded';

export const kiCodeCopy = (t: TFunction) => ({
  label: t('KiCode'),
  newApp: t('New app'),
  editWithKiCode: t('Edit with KiCode'),
  createWithKiCode: t('Create with KiCode'),
  placeholder: t('Describe a change to this app'),
  emptyPrompt: t('Describe what you want to build in this app'),
  newAppPrompt: t('Describe the app you want to build'),
  newChat: t('New chat'),
  newChatConfirm: {
    heading: t('Start a new chat?'),
    body: t('The AI is still working. Starting a new chat stops it.'),
    confirm: t('Start new chat'),
  },
  resize: t('Resize KiCode panel'),
});

export const kiCodeComposerCopy = (
  copy: ReturnType<typeof kiCodeCopy>,
  target: KiCodeTarget
) =>
  target.context.appApiName === undefined
    ? {
        placeholder: copy.newAppPrompt,
        emptyPrompt: copy.newAppPrompt,
      }
    : { placeholder: copy.placeholder, emptyPrompt: copy.emptyPrompt };
